export type SharedTokenSource = "route" | "query" | "pathname" | "missing";

function sanitizeSharedToken(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const withoutSlashes = trimmed.replace(/^\/+|\/+$/g, "");
  if (!withoutSlashes) return null;

  return withoutSlashes;
}

export function normalizeSharedToken(value: string | null | undefined): string | null {
  if (typeof value !== "string") return null;

  try {
    return sanitizeSharedToken(decodeURIComponent(value));
  } catch {
    return sanitizeSharedToken(value);
  }
}

export function resolveSharedDeckToken(params: {
  routeToken?: string | null;
  pathname?: string | null;
  searchParams?: URLSearchParams;
}): { token: string | null; source: SharedTokenSource } {
  const routeToken = normalizeSharedToken(params.routeToken);
  if (routeToken) return { token: routeToken, source: "route" };

  const queryToken = normalizeSharedToken(params.searchParams?.get("token"));
  if (queryToken) return { token: queryToken, source: "query" };

  const pathMatch =
    typeof params.pathname === "string"
      ? params.pathname.match(/^\/(?:share|shared)\/(?!folder\/)([^/?#]+)/i)
      : null;
  const pathToken = normalizeSharedToken(pathMatch?.[1] ?? null);
  if (pathToken) return { token: pathToken, source: "pathname" };

  return { token: null, source: "missing" };
}

export function getSharedTokenDebugMeta(token: string | null, source: SharedTokenSource) {
  return {
    tokenPresent: Boolean(token),
    tokenLength: token?.length ?? 0,
    tokenSource: source,
  };
}
